import { z } from 'zod/v4';

export const CrmContactContract = z.object({
    default: z.boolean(),
    id: z.number(),
    mandatory: z.boolean(),
    name: z.string(),
    options: z.preprocess((value) => (Array.isArray(value) ? value : null), z.array(z.string()).nullable()),
    order: z.number(),
    status: z.number(),
    type: z.number(),
});

export const CrmContactCollectionResponseSchema = z.object({
    data: z.array(CrmContactContract),
});

export type CrmContact = z.infer<typeof CrmContactContract>;
